export default axios => ({
  /**
   * Возвращает список уведомлении
   *
   * @param pageSize
   * @param currentPage
   * @param sort
   * @param order
   * @returns {*}
   */
  list ({ pageSize = 10, currentPage = 1, sort = 'id', order = 'DESC' } = {}) {
    const body = {
      pageSize: pageSize,
      pageIndex: currentPage,
      sort: sort,
      order: order
    }

    return axios.get('/web/notification/list', { params: body })
  }
})
